// 알림 linkUrl이 "웹에 실제로 존재하는 페이지"를 가리키는지 판정한다.
// WEB_ROUTE_PATTERNS는 apps/viewup/app 아래 실존하는 page.tsx 라우트 전체를 세그먼트
// 문자열로 나열한 목록이다. 라우트 추가/삭제 시 갱신, 가드 테스트(isWebRoutableLink.test.ts)가
// 드리프트를 잡는다.
export const WEB_ROUTE_PATTERNS: string[] = [
  '/',
  '/app/privacy-policy',
  '/contact',
  '/faq',
  '/find-account',
  '/find-account/result',
  '/invite',
  '/login',
  '/myviewup',
  '/myviewup/account',
  '/myviewup/account/add',
  '/myviewup/account/auto',
  '/myviewup/account/settings',
  '/myviewup/account/settings/plus',
  '/myviewup/info',
  '/myviewup/info/change-nickname',
  '/myviewup/info/change-password',
  '/myviewup/info/refunds',
  '/myviewup/info/validate',
  '/myviewup/refund',
  '/notice',
  '/notice/[noticeId]',
  '/notifications',
  '/open-viewup',
  '/privacy',
  '/ranking',
  '/reset-password',
  '/reset-password/form',
  '/review-event',
  '/signoz-test',
  '/signoz-test/server-error',
  '/signoz-test/traceparent',
  '/signup',
  '/signup/form',
  '/stamp',
  '/suggest',
  '/viewing',
  '/viewing/click',
  '/viewing/click/auto/progress',
  '/viewing/click/auto/setting',
  '/viewing/post',
  '/viewing/post/apply',
  '/viewing/post/guide',
  '/viewing/post/history',
  '/viewing/post/submit',
  '/viewing-money',
  '/viewing-money/list',
];

const isDynamicSegment = (segment: string) => segment.startsWith('[') && segment.endsWith(']');

const segmentsMatch = (pathSegments: string[], patternSegments: string[]): boolean => {
  if (pathSegments.length !== patternSegments.length) return false;

  return patternSegments.every((patternSegment, i) => {
    const pathSegment = pathSegments[i];
    if (isDynamicSegment(patternSegment)) return pathSegment.length > 0;
    return pathSegment === patternSegment;
  });
};

const toSegments = (pathname: string): string[] =>
  pathname.split('/').filter((segment) => segment.length > 0);

export const isWebRoutableLink = (linkUrl: string): boolean => {
  // 절대 http(s) URL 은 웹에서 그대로 열 수 있다 — 모달 없이 이동
  if (/^https?:\/\//i.test(linkUrl)) return true;

  // `//host/...` 는 protocol-relative 외부 URL — 앱 내부 경로가 아니다
  if (!linkUrl.startsWith('/') || linkUrl.startsWith('//')) return false;

  const withoutQueryAndHash = linkUrl.split(/[?#]/)[0];
  const normalized = withoutQueryAndHash.replace(/\/$/, '') || '/';
  const pathSegments = toSegments(normalized);

  return WEB_ROUTE_PATTERNS.some((pattern) => segmentsMatch(pathSegments, toSegments(pattern)));
};
